import create from 'zustand';
import { persist } from 'zustand/middleware';

const store = (set) => ({
  theme: 'light',
  toggleTheme: () =>
    set((state) => {
      const newTheme = state.theme === 'light' ? 'dark' : 'light';

      if (newTheme === 'dark') {
        document.body.classList.add('eui-dark-theme');
      } else {
        document.body.classList.remove('eui-dark-theme');
      }

      return {
        theme: newTheme,
      };
    }),
  setInitialTheme: () =>
    set((state) => {
      if (state.theme === 'dark') {
        document.body.classList.add('eui-dark-theme');
      } else {
        document.body.classList.remove('eui-dark-theme');
      }

      return {
        theme: state.theme,
      };
    }),
});

export const useThemeStore = create(persist(store, { name: 'eui-docs-theme' }));
